import { LockedAction } from './LockedAction';
import Button from '@components/atoms/button';
import Icon from '@components/atoms/icon';

// FFH-2373: analytics placement for the locked action buttons on Pick.
const LOCKED_ACTION_PLACEMENT = 'pick_action_buttons';

type ActionButtonsProps = {
  onOptimise: () => void;
  onEditTeam: () => void;
  onResetTeam: () => void;
  isOptimising: boolean;
  isDisabled: boolean;
  isEditModeActive: boolean;
  /**
   * Non-paying members see optimise padlocked; clicking it opens the upgrade
   * modal. Editing and resetting the team stay available to everyone.
   */
  isOptimiseLocked?: boolean;
};

export const ActionButtons = ({
  onOptimise,
  onEditTeam,
  onResetTeam,
  isOptimising,
  isDisabled,
  isEditModeActive,
  isOptimiseLocked = false
}: ActionButtonsProps) => (
  <div
    className="flex flex-wrap gap-2 justify-center"
    data-cy="pick-action-buttons"
  >
    {isOptimiseLocked ? (
      <LockedAction
        label="Optimise lineup"
        feature="Optimise lineup"
        placement={LOCKED_ACTION_PLACEMENT}
        dataCy="action-optimise-locked"
      />
    ) : (
      <Button
        variant="primary"
        onClick={onOptimise}
        disabled={isDisabled || isOptimising || isEditModeActive}
        dataCy="action-optimise"
      >
        <span className="inline-flex items-center gap-2">
          <Icon name="SparkleFilled" />
          {isOptimising ? 'Optimising...' : 'Optimise lineup'}
        </span>
      </Button>
    )}
    <Button
      variant={isEditModeActive ? 'primary' : 'secondary'}
      onClick={onEditTeam}
      disabled={isDisabled}
      dataCy="action-edit-team"
    >
      <span className="inline-flex items-center gap-2">
        <Icon name="PenFilled" />
        {isEditModeActive ? 'Done editing' : 'Edit team'}
      </span>
    </Button>
    <Button
      variant="secondary-danger"
      onClick={onResetTeam}
      disabled={isDisabled || isEditModeActive}
      dataCy="action-reset-team"
    >
      <span className="inline-flex items-center gap-2">
        <Icon name="Delete" />
        Reset team
      </span>
    </Button>
  </div>
);
